import { CorporatePage, DefaultMeta } from '../../types/partner-page-types';
import { ISection } from '../Common/navigation/nav-section/index';
import { TCouponDetails, TPlanDetails } from '../S/pricing/types';

export interface IService {
  id: number;
  richText: string;
  serviceImage?: string;
  tooltip?: string;
}

export interface IOfferPricing {
  originalPrice: number;
  discountPercentage: number;
}

export interface IPartnerPlanData {
  planDetails: TPlanDetails;
  coupon: TCouponDetails;
  partnerSlug: string;
}
export interface IFintooResponse {
  email: string;
  mobile: string;
  site_url: string;
}
export interface IPageSection extends ISection {
  postData?: CorporatePage;
  metaData?: DefaultMeta;
}

export enum ProductId {
  SelfFiling = 1,
  EasItr = 2,
}
